import { render, staticRenderFns } from "./treeTestChoice.vue?vue&type=template&id=7f364d42&scoped=true&"
import script from "./treeTestChoice.vue?vue&type=script&lang=js&"
export * from "./treeTestChoice.vue?vue&type=script&lang=js&"
import style0 from "./treeTestChoice.vue?vue&type=style&index=0&id=7f364d42&lang=scss&scoped=true&"
import style1 from "./treeTestChoice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f364d42",
  null
  
)

export default component.exports